import { encodeInteger } from "../utils/base62.mjs";
import { createPayloadEncoder } from "./payloadEncoder.mjs";
function configurePayloadEncoder(opts) {
  let replicant;
  void opts.replicantClientPromise.then((replicantClient) => {
    replicant = replicantClient;
  });
  const useSmallPayloadKeys = opts.gcinstant.platformID === "telegram";
  const payloadEncoder = createPayloadEncoder(() => replicant, opts.analytics, {
    generatePayloadKey: useSmallPayloadKeys ? () => {
      const numericUserId = Number(replicant.userId);
      const userId = Number.isSafeInteger(numericUserId) ? encodeInteger(numericUserId) : replicant.userId;
      return userId + "-" + encodeInteger(Date.now()) + encodeInteger(Number(Math.random().toString().substring(2)));
    } : void 0
  });
  opts.gcinstant.setDataCodec(payloadEncoder);
}
export {
  configurePayloadEncoder
};
